/**
 * Omnisend Popup Translator
 * Translates Omnisend popup text from German to French on FR market.
 * Watches for Omnisend popups injected dynamically into the DOM.
 */
(function () {
    if (!window.Shopify || !window.Shopify.locale) return;
    var lang = window.Shopify.locale.substring(0, 2);
    if (lang !== 'fr') return;

    var translations = {
        // Subheading (must be before "Jetzt eintragen" to match first)
        "Jetzt eintragen und 10% Willkommensrabatt sichern!": "Inscris-toi et profite de 10% de réduction de bienvenue !",
        // Heading
        "Möchtest du 10% auf deine erste Bestellung?": "Tu veux 10% sur ta première commande ?",
        // Consent disclaimer
        "Mit deiner Anmeldung stimmst du dem Erhalt von E-Mails zu.": "En t'inscrivant, tu acceptes de recevoir nos e-mails.",
        // Error messages
        "The email address must contain @ and a valid domain": "L'adresse e-mail doit contenir @ et un domaine valide",
        "Something went wrong!": "Une erreur est survenue !",
        "This field is required": "Ce champ est obligatoire",
        // Teaser tab
        "10% Willkommensrabatt": "10% de réduction",
        // Email placeholder
        "Hier E-Mail eingeben": "Entre ton e-mail ici",
        // Submit button
        "Jetzt eintragen": "Je m'inscris",
        // First name placeholder
        "Vorname": "Prénom"
    };

    // Sort keys by length descending so longer phrases match first
    var sortedKeys = Object.keys(translations).sort(function (a, b) { return b.length - a.length; });

    function translateNode(node) {
        // Text nodes
        if (node.nodeType === 3) {
            var text = node.nodeValue;
            if (!text || !/\S/.test(text)) return;
            var changed = false;
            for (var i = 0; i < sortedKeys.length; i++) {
                var key = sortedKeys[i];
                if (text.indexOf(key) !== -1) {
                    text = text.split(key).join(translations[key]);
                    changed = true;
                }
            }
            if (changed) node.nodeValue = text;
            return;
        }
        // Element nodes
        if (node.nodeType !== 1) return;
        if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;

        // Translate placeholders
        if (node.placeholder) {
            for (var j = 0; j < sortedKeys.length; j++) {
                var k = sortedKeys[j];
                if (node.placeholder.indexOf(k) !== -1) {
                    node.placeholder = node.placeholder.split(k).join(translations[k]);
                }
            }
        }

        // Recurse children
        for (var c = 0; c < node.childNodes.length; c++) {
            translateNode(node.childNodes[c]);
        }
    }

    // Observe body for Omnisend popup injection
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                var el = node.querySelector ? node : null;
                if (!el) return;
                var isOmnisend = (el.className && typeof el.className === 'string' && el.className.indexOf('omnisend-form-') !== -1) ||
                                 el.querySelector('[class*="omnisend-form-"]');
                if (isOmnisend) {
                    translateNode(node);
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();
